const PodcastExplorePage = () => {
    return <div>R24 Podcasts</div>;
}

export default PodcastExplorePage;